import useUrl from './helpers/useUrl'

export default (client) => {
  const v4 = useUrl('v4')
  const root = useUrl('v4/chance')

  return {
    /**
     * @returns {Promise<Response<GetChanceMachineResponse>>}
     * */
    getChanceMachine() {
      const url = v4('chance')
      return client.get(url)
    },
    /**
     * @returns {Promise<Response<SpinChanceMachineResponse>>}
     * */
    spinChanceMachine() {
      const url = root('open')
      return client.post(url, {})
    },
    /**
     * @param {object} ChanceStoryDTO
     * @param {string} ChanceStoryDTO.text
     *
     * @returns {Promise<Response<ChanceStoryResponse>>}
     * */
    chanceStory({ text }) {
      const url = v4('user_chance')
      return client.post(url, { text })
    },
  }
}

/** @typedef {object} GetChanceMachineResponse
 * @property {number} user_id
 * @property {string} lastOpen
 * @property {string} _id
 * @property {object} deposit
 * @property {number} deposit.amount
 * @property {number} deposit.threshold
 * @property {number} deposit.left
 * @property {string} status
 * @property {boolean} isOpened
 * @property {boolean} isExpired
 * @property {string} uuid
 * @property {string} name
 * @property {string} source
 * @property {string} iconUrl
 * @property {string} backgroundUrl
 * @property {object[]} gifts
 * @property {string} gifts.uuid
 * @property {string} gifts.name
 * @property {string} gifts.description
 * @property {string} gifts.iconUrl
 */

/** @typedef {object} SpinChanceMachineResponse
 * @property {boolean} status
 * @property {object} gift
 * @property {string} gift.id
 * @property {string} gift.name
 * @property {string} gift.iconUrl
 */

/** @typedef {object} ChanceStoryResponse
 * @property {boolean} status
 */
